
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import Dator from "@/utils/censor.js";

export default {
name: "nickName",
components: {
XInput,
Group,
Picker,
Popup
},
data() {
return {
popupFlag: false, //區域號碼選擇彈窗
nickname: ""
};
},
methods: {

onClickLeft(){
this.$router.go(-1)
},

showArea() {
this.popupFlag = !this.popupFlag;
},

changeArea() {
this.popupFlag = !this.popupFlag;
},
doSubmit() {
let dator = new Dator.dator();

dator.add(this.nickname, [
{ strategy: "isEmpty", errMsg: this.$t('REGISTER_LANG.inputAppellationTwo') },
{
strategy: "checkStringFormat:2:4",
errMsg: this.$t('REGISTER_LANG.appellationMinLength')
},
{
strategy: "checkStringFormat:12:2",
errMsg: this.$t('REGISTER_LANG.appellationMaxLength')
},
{ strategy: "checkName", errMsg: this.$t('REGISTER_LANG.appellationErr') }
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

let postD = {
nickname: this.nickname
};
this.$toast.loading();
this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.UPDATEINFO, postD, "POST")
.then(res => {
this.$toast.close();
this.$toast.text( this.$t('NICKNAME_LANG.saveSuccess'));

setTimeout(() => {
this.$toast.close();
this.GLOBAL_.ccApp.navigateBack();
}, 1000);
})
.catch(err => {
this.$toast.text(this.$t('NICKNAME_LANG.saveFail'));
});
}
},
created() {
this.nickname = this.$route.query.nickname || "";
},
mounted() {

}
};



// WEBPACK FOOTER //
// ./src/pages/me/nickName.vue